import type { ErrorComponentProps } from '@tanstack/react-router';
import { useEffect } from 'react';

import { Card, CardContent, CardHeader, CardTitle } from '#/components/ui/card.tsx';
import { appInsights } from '#/telemetry/app-insights.ts';

/**
 * エラーページコンポーネント
 * @param props - エラー情報を含むプロパティ
 * @param props.error - エラーオブジェクト
 * @returns エラーページコンポーネント
 */
export const ErrorPage = ({ error }: ErrorComponentProps) => {
  useEffect(() => {
    // エラーバウンダリが捕捉した例外は自動収集されないため明示的に送信する
    appInsights.trackException({ exception: error });
  }, [error]);

  const isDevelopment = import.meta.env.DEV;
  const errorMessage =
    isDevelopment && error instanceof Error ? error.message : 'エラーが発生しました';

  return (
    <div className="container mx-auto p-4">
      <Card className="border-red-500">
        <CardHeader>
          <CardTitle className="text-red-500">エラーが発生しました</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-red-500">{errorMessage}</p>
        </CardContent>
      </Card>
    </div>
  );
};
